// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"e7ea0977e2bfb298","9777":"1a6a74a892dca26a"}[chunkId] + ".js";
};